import { type VariantProps } from "class-variance-authority"
import { type Badge } from "@/components/ui/badge"

export const getStatusColor = (status: string) => {
  switch (status) {
    case "payment_pending":
      return "secondary" // Yellow for pending actions
    case "payment_done":
      return "default" // Primary color for successful payments
    case "payment_failed":
      return "destructive" // Red for failed payments
    case "event_booked":
      return "default" // Primary color for confirmed bookings
    case "event_in_progress":
      return "secondary" // Yellow for ongoing events
    case "event_complete":
      return "default" // Primary color for completed events
    case "event_cancelled":
      return "destructive" // Red for cancelled events
    default:
      return "secondary" // Secondary color for unknown status
  }
}

export const formatStatus = (status: string) => {
  switch (status) {
    case 'payment_pending':
      return 'Booked Tentatively'
    case 'payment_done':
      return 'Event Booked'
    case 'payment_failed':
      return 'Event Cancelled'
    default:
      return status.replace(/_/g, ' ')
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ')
  }
}

export const isInactiveEvent = (status: string) => {
  return [
    'event_cancelled',
    'payment_failed',
    'payment_pending'
  ].includes(status)
}
